import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import { OPEN_ROOM_BUG } from "../../../../graphql/mutations/management";
import { FETCH_ROOMS } from "../../../../graphql/queries/management";
import { onChangeBugForm, toggleBugModal } from "../../redux/roomSlice";
import CustomSwitch from "../../../../components/form/CustomSwitch";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const RoomBugForm = () => {
  const dispatch = useDispatch();
  const { openBugForm } = useSelector((state) => state.room);

  const [openRoomBug, { loading }] = useMutation(OPEN_ROOM_BUG, {
    variables: { isBugOpen: openBugForm.isBugOpen, id: openBugForm.id },
    refetchQueries: [{ query: FETCH_ROOMS }],
    onCompleted: (data) => {
      if (data.openRoomBug) {
        dispatch(toggleBugModal());
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    openRoomBug();
  };

  const toggleSwitch = () => dispatch(onChangeBugForm());

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomSwitch
        labelSize={3}
        inputSize={9}
        label="ເປີດ/ປິດບັກ"
        onChange={toggleSwitch}
        value={openBugForm.isBugOpen}
      />
      <div className="text-center">
        <SubmitButton loading={loading} />
      </div>
    </Form>
  );
};

export default RoomBugForm;
